import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";
import { createGenerateReportHandler } from "../reports/sagas";

import {
  iataFetchError,
  iataFetchRequest,
  iataFetchSuccess,
  reportGeneratorTaskCreateRequest,
  tableFetchError,
  tableFetchRequest,
  tableFetchSuccess,
} from "./actions";
import { AirlinesActionTypes } from "./types";

export function* handleAirlinesItemsFetch(action: ReturnType<typeof tableFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/airlines/", action.payload, source.token);
    yield put(tableFetchSuccess(res.data));
  } catch (err) {
    yield put(tableFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleAirlinesIataFetch(action: ReturnType<typeof iataFetchRequest>): SagaIterator {
  try {
    const { iata, ...payload } = action.payload;
    const res = yield call(callGet, `/airlines/${iata}/`, payload);
    yield put(iataFetchSuccess({ items: res.data, iata }));
  } catch (err) {
    yield put(iataFetchError(err.message));
  }
}

const handleAirlinesReportFetch = createGenerateReportHandler<ReturnType<typeof reportGeneratorTaskCreateRequest>>(
  "/airlines/report/"
);

function* watchAirlinesSagas(): SagaIterator {
  yield takeLatest(AirlinesActionTypes.TABLE_FETCH_REQUEST, handleAirlinesItemsFetch);
  yield takeLatest(AirlinesActionTypes.IATA_FETCH_REQUEST, handleAirlinesIataFetch);
  yield takeLatest(AirlinesActionTypes.GENERATE_REPORT_REQUEST, handleAirlinesReportFetch);
}

export default watchAirlinesSagas;
